import { CardBody } from "@chakra-ui/react";
import { EventType } from "@models/event";
import { DEFAULT_LANGUAGE, Language } from "@models/language";
import { useMemo } from "react";
import { HiPlus } from "react-icons/hi";
import { CardCover, CustomCard } from "../CheckoutSuccessCTA";

const _t = (key?: string, language = DEFAULT_LANGUAGE) => key || "";

const CREATE_EVENT_LINK =
  process.env.NEXT_PUBLIC_CREATE_EVENT_LINK ||
  "https://airtable.com/appwKoJQow1T81K1n/shrggziH4WiBzhN4B";
const CREATE_MEMBERSHIP_LINK =
  process.env.NEXT_PUBLIC_CREATE_MEMBERSHIP_LINK ||
  "https://airtable.com/appwKoJQow1T81K1n/shrjCL9Fc9fXgnaf3";
const CREATE_BENEFIT_LINK =
  process.env.NEXT_PUBLIC_CREATE_BENEFIT_LINK ||
  "https://airtable.com/appOW1mPD9IXbO6ON/shreScHI54RxE4pvM";

const CreateEventCard = ({
  language,
  type,
}: {
  language: Language;
  type?: EventType;
}) => {
  const creation = useMemo(() => {
    switch (type) {
      case EventType.BENEFIT:
        return { title: "Create Benefit", link: CREATE_BENEFIT_LINK };
      case EventType.MEMBERSHIP:
        return {
          title: "Create Membership",
          link: CREATE_MEMBERSHIP_LINK,
        };
      case EventType.TICKET:
      default:
        return {
          title: "Create Event",
          link: CREATE_EVENT_LINK,
        };
    }
  }, [type]);

  const handleClick = () => {
    // open link in new tab
    window.open(creation.link, "_blank");
  };

  return (
    <CustomCard onClick={handleClick}>
      <CardBody>
        <CardCover
          icon={<HiPlus className="text-primary-500" size={20} />}
          alt="create event icon"
          title={_t(creation.title, language)}
        />
      </CardBody>
    </CustomCard>
  );
};

export default CreateEventCard;
